import { UploadAssetsURL } from "../components/Dam/DAM_API/urls";
import Axios from "./Axios";

export const startUploadAssets = async (formData, onProgress , uploadurl) => {
    if (typeof window === "undefined") {
        throw new Error("Upload must run in browser");
    }
    
    const response = await Axios.post(
       uploadurl? uploadurl : UploadAssetsURL,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            // Old version
            progress(progressEvent) {
                console.log({ progressEvent });
            },
            // New version
            onUploadProgress: (e) => {
                if (!e.total) return;
                const percent = Math.round((e.loaded * 100) / e.total);
                onProgress?.(percent);
            },
        }
    );

    if (response.status === 202) {
        return { status: "PREPARING", uploadId: response.data.data };
    }

    if (response.status === 200) {
        return { status: "DONE", uploadId: response.data.data };
    }

    throw new Error("Upload failed");
};
